module.exports = __webpack_public_path__ + "public/files/img/whats-3.9c2d9776.png";